export default "/images/vendor/flag-icon-css/flags/1x1/kh.svg?e7fb0dfc1a7ba25626b05ba502bb0e73";